import deleteExamModuleDoc from '../../api/examModules/deleteExamModuleDoc';
import {useFunctionWrap} from '../helper/function/useFunctionWrap';

export default function useDeleteExamModule() {
  const {fn, loading, error} = useFunctionWrap(deleteExamModuleDoc);

  return {
    deleteExamModule: fn,
    loading,
    error,
  };
}
